import { Button } from "@/ui";
import { Box, SxProps, Theme } from "@ui";
import React from "react";

export interface DoubleToggleProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  trueLabel?: string;
  falseLabel?: string;
  selectedColor?: string;
  textColor?: string;
  nonSelectedColor?: string;
  sx?: SxProps<Theme>;
}

const DoubleToggle: React.FC<DoubleToggleProps> = ({
  value,
  onChange,
  trueLabel = "Yes",
  falseLabel = "No",
  selectedColor = "#165F54",
  textColor = "#FFFFFF",
  nonSelectedColor = "#fff",
  sx,
}) => {
  const getButtonStyles = (active: boolean): SxProps<Theme> => {
    const isSelected = value === active;

    return {
      borderRadius: active ? "13px 0 0 13px" : "0 13px 13px 0",
      boxShadow: "none",
      textTransform: "none",
      padding: "7px 14px",
      minWidth: "40px",
      backgroundColor: isSelected ? selectedColor : nonSelectedColor,
      color: isSelected ? textColor : "#000",
      "&:hover": {
        backgroundColor: isSelected ? selectedColor : "#f0f0f0",
      },
      fontSize: 15,
      fontWeight: 400,
    };
  };

  const handleClick = (newValue: boolean) => {
    if (value === newValue) {
      onChange(null);
    } else {
      onChange(newValue);
    }
  };

  return (
    <Box display="flex" width="fit-content" sx={sx}>
      <Button onClick={() => handleClick(true)} sx={getButtonStyles(true)}>
        {trueLabel}
      </Button>
      <Button onClick={() => handleClick(false)} sx={getButtonStyles(false)}>
        {falseLabel}
      </Button>
    </Box>
  );
};

export default DoubleToggle;
